import React, { useState, useRef } from 'react'
import { FormControl, FormHelperText, Button } from '@material-ui/core'
import Typography from '@material-ui/core/Typography'
import Papa from 'papaparse'
import makeStyles from '@material-ui/core/styles/makeStyles'

function FileUpload({ headerText, onUpload }) {
  const inputFileRef = useRef()
  const [csvFile, setCsvFile] = useState(null)
  const [csvError, setCsvError] = useState(null)
  const classes = useStyles()

  const handleFileChange = (event) => {
    const file = event.target.files[0]
    if (file) {
      if (file.type !== 'text/csv') {
        setCsvError('Invalid file type. Please upload a CSV file.')
      } else {
        setCsvError(null)
      }
      setCsvFile(file)
    } else {
      setCsvFile(null)
      setCsvError(null)
    }
    event.target.value = null
  }

  const handleUploadClick = () => {
    if (csvFile) {
      Papa.parse(csvFile, {
        header: false,
        complete: async (results) => {
          const data = results.data
          data.pop()
          await onUpload(data)
          setCsvFile(null)
          setCsvError(null)
        },
        error: (error) => {
          setCsvError(error)
        }
      })
    }
  }

  return (
    <div className={classes.root}>
      <Typography variant="h4" className={classes.heading}>
        {headerText}
      </Typography>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <FormControl error={Boolean(csvError)}>
          <Button
            color="primary"
            size="small"
            className={classes.upload}
            onClick={() => inputFileRef.current.click()}>
            {csvFile ? csvFile.name : 'Upload a file'}
            <input
              id="csv-file-input"
              type="file"
              accept=".csv"
              onChange={handleFileChange}
              ref={inputFileRef}
              className={classes.input}
            />
          </Button>
        </FormControl>
        <Button
          variant="contained"
          color="primary"
          onClick={handleUploadClick}
          disabled={!csvFile || csvError}>
          Create
        </Button>
      </div>
      {csvError && <FormHelperText className={classes.error}>{csvError}</FormHelperText>}
    </div>
  )
}

export default FileUpload

const useStyles = makeStyles(() => ({
  root: {
    padding: '0px 10px'
  },
  heading: {
    fontSize: '20px',
    marginBottom: '10px'
  },
  upload: {
    textTransform: 'none',
    minWidth: '320px',
    justifyContent: 'start',
    padding: '12px',
    fontSize: '13px',
    fontWeight: 600,
    border: '1px solid #D9E0E9',
    borderRadius: '24px',
    background: '#FFFFFF',
    marginRight: '20px'
  },
  input: {
    display: 'none'
  },
  error: {
    marginTop: '5px',
    marginLeft: '15px',
    color: '#ec2625'
  }
}))
